export enum StatoPuntoFatturazione {
  'DA FATTURARE' = 1,
  'FATTURATO',
}
